/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Readiness_DescInputs */

const en_mk_nav_readiness_desc = /** @type {(inputs: Mk_Nav_Readiness_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your plan before you start building.`)
};

const id_mk_nav_readiness_desc = /** @type {(inputs: Mk_Nav_Readiness_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa kesiapan rencana sebelum membangun.`)
};

/**
* | output |
* | --- |
* | "Check your plan before you start building." |
*
* @param {Mk_Nav_Readiness_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_readiness_desc = /** @type {((inputs?: Mk_Nav_Readiness_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Readiness_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_readiness_desc(inputs)
	return en_mk_nav_readiness_desc(inputs)
});